import { REST } from 'utils/rest';

const url = '/api/sequences/';

export class SequenceAPI {
  // To create a new sequence
  static post(data, onSuccess, onError) {
    return REST.post(url, data, onSuccess, onError);
  }
}
